import { SymbolsAnimationFactory } from './SymbolsAnimationFactory'
import { SymbolContainerData } from '@/modules'

export class ScatterSymbolsFactory extends SymbolsAnimationFactory {
    public getAnimationResource(): string {
        return 'BONUS'
    }

    public getAnimationLabel(symbolData: SymbolContainerData, state: string): string {
        return ScatterSymbolsFactory.ANIMATIONS[state]
    }

    public static readonly ANIMATIONS: Record<string, string> = {
        ['trigger']: 'animation',
    }
}
